import type { Maybe } from '@adornis/base/utilTypes.js';

export enum MarktAkquiseStatus {
  NEW = 'Neu',
  IN_PROGRESS = 'In Arbeit',
  DONE = 'Fertig',
  DENIED = 'Abgelehnt',
  ENDED = 'Beendet',
}

export function marktAkquiseStatusColor(status: Maybe<string>): string {
  switch (status) {
    case 'NEW':
      return 'lightgray';
    case 'IN_PROGRESS':
      return 'orange';
    case 'OK':
    case 'DONE':
      return '#afca00';
    case 'DENIED':
      return '#df7373';
    case 'ENDED':
      return '#588157';
    case 'TODO':
      return '#219ebc';
    default:
      return 'lightgray';
  }
}

export function marktAkquiseStatusText(status: Maybe<string>) {
  switch (status) {
    case 'NEW':
      return 'Neu';
    case 'IN_PROGRESS':
      return 'In Arbeit';
    case 'DONE':
      return 'Fertig';
    case 'DENIED':
      return 'Abgelehnt';
    case 'ENDED':
      return 'Beendet';
    default:
      return status;
  }
}
